import React from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import RegularExpression from '../../constants/RegularExpression';
import { getAffiliatesInfo } from '../../actions/AffiliateActions';
import { createNewDomain, getDomainsForAffiliate, deleteDomain, checkActivityForAffiliate } from '../../actions/DomainsActions';
import { Table, Pagination, Button, Modal, Input, Form, Select, DatePicker, Icon, Spin, Divider } from "antd";

const { Option } = Select;
const confirm = Modal.confirm;

class Domains extends React.Component {

    state = {
        addModalvisible: false,
        pageNumber: 1
    };

    componentDidMount() {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        mainPartnerId && this.props.dispatch(getDomainsForAffiliate(mainPartnerId, pageNumber));
        mainPartnerId && this.props.dispatch(getAffiliatesInfo(mainPartnerId));
    }

    onPageChange = (current) => {
        this.setState({ pageNumber: current });
    };

    // On page and mainpartner change get new data
    componentDidUpdate(prevProps, prevState) {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;
        const { filterAffId, filterDate, filterStatus } = this.state;

        if (prevState.pageNumber !== pageNumber || prevProps.affiliates.mainPartnerId !== mainPartnerId) {
            this.props.dispatch(getDomainsForAffiliate(mainPartnerId, pageNumber, {
                filterAffId,
                filterDate: filterDate && filterDate.format('YYYY-MM-DD'),
                filterStatus
            }));
        }
    }

    showAddDomainModal = () => {
        this.setState({
            addModalvisible: true,
        });
    };

    handleModalCancel = e => {
        this.setState({
            addModalvisible: false
        });
    };

    handleAddDomain = (e) => {
        e.preventDefault();

        const { form } = this.props;
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        form.validateFields((err, values) => {
            if (!err) {
                const formData = {
                    affiliateId: parseInt(values.affiliateId, 10),
                    domain: values.domain,
                    status: values.status
                }

                this.props.dispatch(createNewDomain(formData, this.props.intl)).then(() =>
                    this.props.dispatch(getDomainsForAffiliate(mainPartnerId, pageNumber))
                );
                this.handleModalCancel();
            }
        })
    };

    handleFilterDomains = () => {
        const { form } = this.props;
        const { mainPartnerId } = this.props.affiliates;

        this.onPageChange(1);

        form.validateFields((err, values) => {
            if (!err) {
                const { filterAffId, filterDate, filterStatus } = values;

                this.setState({
                    filterAffId: values.filterAffId,
                    filterStatus: values.filterStatus
                });

                this.props.dispatch(getDomainsForAffiliate(mainPartnerId, 1, {
                    filterAffId,
                    filterDate: filterDate && filterDate.format('YYYY-MM-DD'),
                    filterStatus
                }))
            }
        })
    };

    handleDeleteDomain = (e, row, index) => {
        const that = this;
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        confirm({
            title: this.props.intl.messages.delete,
            content: <div className="ta--footer-delete-item ">
                <p className='ta--pb-0'>{this.props.intl.messages.confirm_domain_delete}</p>
            </div>,
            okText: this.props.intl.messages.delete,
            onOk() {
                that.props.dispatch(deleteDomain(mainPartnerId, row.id, that.props.intl)).then(() =>
                    that.props.dispatch(getDomainsForAffiliate(mainPartnerId, pageNumber))
                )
            },
            onCancel() {
            },
        });
    };

    checkActivity = (e, row, index) => {
        const { mainPartnerId } = this.props.affiliates;
        const { pageNumber } = this.state;

        this.props.dispatch(checkActivityForAffiliate(row.id)).then(() =>
            this.props.dispatch(getDomainsForAffiliate(mainPartnerId, pageNumber))
        );
    };

    clearItem = (type) => {
        this.props.form.setFieldsValue({
            [type]: undefined,
        });
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { addModalvisible } = this.state;
        const { affiliatesInfo } = this.props.affiliates;
        const { affDomains } = this.props.domains;

        const sorter = (a, b) => {
            if (a.id < b.id) {
                return -1;
            }
            if (a.id > b.id) {
                return 1;
            }
            return 0;
        };

        const columns = [
            {
                title: this.props.intl.messages.id,
                dataIndex: 'id',
                key: 'id',
                filters: [],
                sorter: sorter,
                sortDirections: ['ascend' , 'descend']
            },
            {
                title: this.props.intl.messages.aff_name,
                dataIndex: 'aff_name',
                key: 'aff_name'
            },
            {
                title: this.props.intl.messages.date,
                dataIndex: 'date',
                key: 'date'
            },
            {
                title: this.props.intl.messages.ns_1,
                dataIndex: 'ns_1',
                key: 'ns_1'
            },
            {
                title: this.props.intl.messages.ns_2,
                dataIndex: 'ns_2',
                key: 'ns_2'
            },
            {
                title: this.props.intl.messages.domain,
                dataIndex: 'domain',
                key: 'domain',
                render: (text) => <a href={'http://www.' + text} target="_blank">{text}</a>
            },
            {
                title: this.props.intl.messages.status,
                dataIndex: 'status',
                key: 'status',
                render: (amount, record) => (
                    <span className={record.status === 1 ? "ta--active ta--fw-b" : "ta--pending ta--fw-b"}>
                        {record.status === 1 ? this.props.intl.messages.active : this.props.intl.messages.pending}
                    </span>
                )
            },
            {
                title: '',
                dataIndex: 'settings',
                key: 'settings',
                width: '30px',
                render: (value, row, index) => (
                    <div className='ta--flex'>
                        <Button disabled={row.status === 1 || !row.is_active_affiliate} onClick={(e) => this.checkActivity(e, row, index)} size="small" className='ta--mb-2 ta--mt-4 ta--mr-32' key="done" type="primary">
                            {this.props.intl.messages.check_activity}
                        
                        </Button>
                        <i onClick={(e) => this.handleDeleteDomain(e, row, index)} className='delete-icon ta--f-20'></i>
                    </div>
                ),
            },
        ];

        const antIcon = <Icon type="loading" className="ta--ant_loader" spin />;

        const affNames = affiliatesInfo && Object.keys(affiliatesInfo).map((key) =>
                <Option key={key} value={key}>{affiliatesInfo[key]}</Option>
        );

        let tableData = [];

        if (affDomains && affDomains.Domains) {
            tableData = Object.keys(affDomains.Domains).map(key => {
                return {
                    id: affDomains.Domains[key].Id,
                    key: affDomains.Domains[key].Id,
                    aff_name: affDomains.Domains[key].AffiliateName,
                    date: moment(affDomains.Domains[key].Date).format("DD/MM/YYYY HH:mm"),
                    domain: affDomains.Domains[key].DomainName,
                    status: affDomains.Domains[key].Status,
                    condition: affDomains.Domains[key].Status === 1,
                    is_active_affiliate: affDomains.Domains[key].IsActiveAffiliate,
                    ns_1: affDomains.Domains[key].Nameserver1,
                    ns_2: affDomains.Domains[key].Nameserver2
                }
            }).sort(sorter);
        }

        return (
            <div>
                <div className="ta--flex ta--justify-between ta--align-center rtl--row-reverse">
                    <h2 className='ta--main-header ta--flex ta--align-center ta--justify-between rtl--row-reverse'>{this.props.intl.messages.domains}
                        {/*<Tooltip placement="bottomLeft" title={`aarav.ns.cloudflare.com lina.ns.cloudflare.com`}>
                            <i className='ta--mh-8 info-icon'></i>
                        </Tooltip>*/}
                    </h2>
                    <Button type="primary" onClick={this.showAddDomainModal}>{this.props.intl.messages.add_new}</Button>
                </div>

                <div className='ta--flex ta--domains-filter ta--filter'>
                    <Form layout="vertical" className='ta--flex ta--align-center ta-flex-grid ta-w100 '>
                        <Form.Item label={this.props.intl.messages.aff_name} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('filterAffId')(
                                <Select
                                 placeholder={this.props.intl.messages.aff_name}
                                 dropdownRender={menu => (
                                    <div>
                                      {menu}
                                      <Divider className="ant-select-tree-dropdown" />
                                        <div
                                        className="ant-select-tree-dropdown-render-div"
                                        onMouseDown={e => e.preventDefault()}
                                        onClick={() => this.clearItem('filterAffId')}
                                      >
                                        <Icon type="delete" /> Clear
                                      </div>
                                    </div>
                                  )}
                                 >
                                    {affNames}
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.date} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('filterDate')(
                                <DatePicker />
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.status} className='ta--flex-grid__item ta--col-2'>
                            {getFieldDecorator('filterStatus')(
                                <Select 
                                    placeholder={this.props.intl.messages.status} 
                                    className='ta-w100'
                                    dropdownRender={menu => (
                                        <div>
                                        {menu}
                                        <Divider className="ant-select-tree-dropdown" />
                                          <div
                                            className="ant-select-tree-dropdown-render-div"
                                            onMouseDown={e => e.preventDefault()}
                                            onClick={() => this.clearItem('filterStatus')}
                                        >
                                            <Icon type="delete" /> Clear
                                        </div>
                                        </div>
                                    )}
                                >
                                    <Option value={1}>{this.props.intl.messages.active}</Option>
                                    <Option value={2}>{this.props.intl.messages.pending}</Option>
                                    {/*<Option value='BlockedByAdmin'>{this.props.intl.messages.blocked_by_admin}</Option>*/}
                                </Select>
                            )}
                        </Form.Item>

                        <Button onClick={this.handleFilterDomains} className='ta--mb-4 ta--mt-24' key="done" type="primary">{this.props.intl.messages.filter}</Button>
                    </Form>
                </div>

                <Spin indicator={antIcon} spinning={this.props.domains.inProcess}>
                    <Table
                        dataSource={tableData.sort(sorter)}
                        columns={columns}
                        pagination={false}
                        className="ta-aff-table ta--mt-8"
                        footer={() => <div className='ta--pagination-rows'>{this.props.intl.messages.total_rows}:{affDomains && affDomains.RowCount}</div>}
                    >
                    </Table>
                    <Pagination current={this.state.pageNumber} pageSize={13} total={affDomains && affDomains.RowCount} onChange={this.onPageChange} />
                </Spin>

                {/* Add Domain Modal */}
                {addModalvisible && <Modal
                    title={this.props.intl.messages.add_domain}
                    visible={addModalvisible}
                    centered
                    onCancel={this.handleModalCancel}
                    footer={[
                        <React.Fragment>
                            <Button onClick={this.handleModalCancel} key="cancel">{this.props.intl.messages.cancel}</Button>
                            <Button onClick={this.handleAddDomain} key="save" type="primary">{this.props.intl.messages.save}</Button>
                        </React.Fragment>
                    ]}
                >
                    <Form >
                        <Form.Item label={this.props.intl.messages.affiliate} >
                            {getFieldDecorator('affiliateId', {
                                rules: [{
                                    required: true,
                                    message: this.props.intl.messages.required_field
                                }],
                            })(
                                <Select placeholder={this.props.intl.messages.affiliate} className='ta-w100'>
                                    {affNames}
                                </Select>
                            )}
                        </Form.Item>

                        <Form.Item label={this.props.intl.messages.domain} >
                            {getFieldDecorator('domain', {
                                rules: [{
                                    required: true,
                                    message: this.props.intl.messages.required_domain
                                },
                                { pattern: RegularExpression.DOMAIN_VALIDATION, message: this.props.intl.messages.domain_validation_message }
                                ],
                            })(
                                <Input placeholder={this.props.intl.messages.your_domain} autoComplete="off" maxLength={50} />
                            )}
                        </Form.Item>

                        {/* <Form.Item label={this.props.intl.messages.status} >
                            {getFieldDecorator('status', {
                                rules: [{
                                    required: true,
                                    message: this.props.intl.messages.required_field
                                }],
                            })(
                                <Select placeholder={this.props.intl.messages.status} className='ta-w100'>
                                    <Option value={1}>{this.props.intl.messages.active}</Option>
                                    <Option value={2}>{this.props.intl.messages.blocked}</Option>
                                </Select>
                            )}
                        </Form.Item> */}
                    </Form>
                </Modal>}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        affiliates: state.affiliates,
        domains: state.domains,
        user: state.user
    };
};

const mapDispatchToProps = (dispatch, props) => {
    return ({
        dispatch
    })
}

export default injectIntl(connect(
    mapStateToProps,
    mapDispatchToProps
)(Form.create()(Domains)));


// WEBPACK FOOTER //
// ./src/routes/mainAffilate/Domains.js